import { Injectable } from '@angular/core';
import { Router, Resolve } from '@angular/router';
import { Observable, throwError, of, take, catchError, mergeMap } from 'rxjs';
import { UserApiService } from '../../api/api/user-api.service';
import { CurrentUserService } from '../../services/current-user.service';
import { GlobalNavigationService } from '../../services/global-navigation.service';
import { User } from '../../types/user/user';
import { noDefaultErrorHandler } from '../../services/interceptors/error-handler/operators/no-default-error-handler.operator';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserResolverService implements Resolve<User> {
  constructor(
    private userApi: UserApiService,
    private router: Router,
    private currentUserService: CurrentUserService,
    private globalNavigationService: GlobalNavigationService,
  ) {}

  resolve(): Observable<User> {
    return this.userApi.getLoggedInUser().pipe(
      take(1),
      noDefaultErrorHandler(),
      catchError((err) => {
        this.globalNavigationService.goHome();
        return throwError(err);
      }),
      mergeMap((currentUser) => {
        if (currentUser) {
          this.currentUserService.setAptitudeUser(currentUser);
          return of(currentUser);
        } else {
          // id not found or permission denied
          this.globalNavigationService.goHome();
          return throwError('Empty object from rfpApi');
        }
      }),
    );
  }
}
